import { render, staticRenderFns } from "./ManualShiftAssignmentBulk.vue?vue&type=template&id=4491ef51"
import script from "./ManualShiftAssignmentBulk.vue?vue&type=script&lang=js"
export * from "./ManualShiftAssignmentBulk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports